/* eslint-disable sonarjs/cognitive-complexity */
import * as React from 'react';

import { SearchButtonAdvanced, SearchFilter } from '@/components/search-button-advanced';
import { SelectorAPI } from '@/components/selector-api';
import { SelectorDateRange } from '@/components/selector-daterange';
import { SelectorList } from '@/components/selector-list';
import { allStatuses } from '@/helper/lists';

enum FilterType {
  Company = 'company',
  Contact = 'contact',
  Project = 'project',
  DateRange = 'dateRange',
  Mixer = 'mixer',
  Status = 'status'
}

interface Properties {
  moveRight?: boolean;
  draggable?: boolean;
  disabled?: boolean;
}

function validateSearchArray(searchArray: any[]) {
  let errorsUpdate: Record<string, string> = {};

  for (const [index, search] of searchArray.entries()) {
    switch (search.type) {
      case FilterType.Company: {
        if (search.id == 0) errorsUpdate = { ...errorsUpdate, [index + '_companyId']: 'No Company Selected!' };
        break;
      }
      case FilterType.Contact: {
        if (search.id == 0) errorsUpdate = { ...errorsUpdate, [index + '_contactId']: 'No Contact Selected!' };
        break;
      }
      case FilterType.Project: {
        if (search.id == 0) errorsUpdate = { ...errorsUpdate, [index + '_projectId']: 'No Project Selected!' };
        break;
      }
      case FilterType.DateRange: {
        if (!search.startDate) errorsUpdate = { ...errorsUpdate, [index + '_startDate']: 'No Start Date Selected!' };
        if (!search.endDate) errorsUpdate = { ...errorsUpdate, [index + '_endDate']: 'No End Date Selected!' };
        break;
      }
      case FilterType.Mixer: {
        if (!search.id) errorsUpdate = { ...errorsUpdate, [index + '_mixerId']: 'No Mixer Selected!' };
        break;
      }
      case FilterType.Status: {
        if (!search.name) errorsUpdate = { ...errorsUpdate, [index + '_status']: 'No Status Selected!' };
        break;
      }
    }
  }

  return errorsUpdate;
}

function renderFilter(filter: SearchFilter, index: number) {
  switch (filter.type) {
    case FilterType.Company: {
      return <SelectorAPI name={index + '_company'} displayName='Company' value={filter.id} fetchURL='/companies' />;
    }
    case FilterType.Contact: {
      return <SelectorAPI name={index + '_contact'} displayName='Contact' value={filter.id} fetchURL='/contacts' />;
    }
    case FilterType.Project: {
      return <SelectorAPI name={index + '_project'} displayName='Project' value={filter.id} fetchURL='/projects' />;
    }
    case FilterType.DateRange: {
      return <SelectorDateRange value={{ startDate: filter.startDate, endDate: filter.endDate }} index={index} />;
    }
    case FilterType.Mixer: {
      return <SelectorAPI name={index + '_mixer'} displayName='Mixer' value={filter.id} fetchURL='/users/mixers' />;
    }
    case FilterType.Status: {
      return <SelectorList name={index + '_status'} displayName='Status' value={filter.name} list={allStatuses} />;
    }
    default: {
      return;
    }
  }
}

export function SearchButtonSessions({ moveRight = false, draggable = false, disabled = false }: Properties) {
  return (
    <SearchButtonAdvanced
      modalTitle='Search Sessions'
      formId='adv-search-sessions'
      filtersAvailable={Object.values(FilterType)}
      renderFilter={renderFilter}
      validateSearchArray={validateSearchArray}
      moveRight={moveRight}
      draggable={draggable}
      disabled={disabled}
    />
  );
}
